import { Question } from '@jupiterone/jupiter-types/question';
const BRACKETS_REGEX = /{{(.*?)}}/g;

const stripDoubleBrackets = (val: string) =>
  val.replace('{{', '').replace('}}', '');

export const queryHasTemplates = (query: string): boolean =>
  getQueryTemplateVariables(query).length > 0;

export const questionHasTemplates = (question: Question) =>
  question.queries.reduce((acc, { query }) => {
    if (queryHasTemplates(query)) {
      return true;
    }
    return acc;
  }, false);

export const getQueryTemplateVariables = (query: string): string[] => {
  const result = query.match(BRACKETS_REGEX);
  return result ? result.map(stripDoubleBrackets) : [];
};

export const injectVariablesIntoQuery = (
  query: string,
  variables: { [variableName: string]: string }
): string =>
  Object.keys(variables).reduce(
    (acc, variable) => acc.replace(`{{${variable}}}`, variables[variable]),
    query
  );
